<template>
    <div class="view-inner">
        <div v-if="isLoading" class="loading-overlay">
            <div class="spinner-border text-light" role="status"></div>
            <p>Cargando...</p>
        </div>

        <!-- Page Header -->
        <div class="page-header">
            <h1 class="page-header-title"><i class="bi bi-truck"></i> Gestión de Vehículos</h1>
            <div class="page-header-actions">
                <button class="btn-add" @click="abrirModalVehiculo()">
                    <i class="bi bi-plus-lg"></i> Agregar Vehículo
                </button>
            </div>
        </div>

        <!-- Filtros -->
        <div class="filter-card">
            <div class="row">
                <div class="col-md-3">
                    <label class="form-label">Nombre del Vehículo</label>
                    <input type="text" class="form-control form-control-sm" v-model="filtros.nombre_vehiculo" placeholder="Buscar por nombre...">
                </div>
                <div class="col-md-2">
                    <label class="form-label">Placa</label>
                    <input type="text" class="form-control form-control-sm" v-model="filtros.placa" placeholder="Buscar por placa...">
                </div>
                <div class="col-md-2">
                    <label class="form-label">Tipo Vehículo</label>
                    <select class="form-select form-select-sm" v-model="filtros.id_tipo_vehiculo">
                        <option value="">Todos</option>
                        <option v-for="tipo in tiposVehiculo" :key="tipo.id" :value="tipo.id">{{ tipo.nombre_tipo || tipo.tipo_vehiculo }}</option>
                    </select>
                </div>
                <div class="col-md-2">
                    <label class="form-label">Estado</label>
                    <select class="form-select form-select-sm" v-model="filtros.estado_vehiculo_id">
                        <option value="">Todos</option>
                        <option v-for="estado in estadosVehiculo" :key="estado.id" :value="estado.id">{{ estado.estado }}</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label class="form-label">&nbsp;</label>
                    <div class="filter-actions">
                        <button class="btn-clear" @click="limpiarFiltros"><i class="bi bi-x-circle"></i> Limpiar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tabla (estándar: ESTANDAR_LISTADOS.md) -->
        <div>
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                                <th>ID</th>
                                <th>Nombre</th>
                                <th>Tipo Vehículo</th>
                                <th>Tipo Unidad</th>
                                <th>Marca</th>
                                <th>Modelo</th>
                                <th>Placa</th>
                                <th>Estado</th>
                                <th>Orden</th>
                                <th class="col-acciones">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="vehiculo in paginar(vehiculosFiltrados)" :key="vehiculo.id_vehiculo">
                                <td class="celda-id">{{ vehiculo.id_vehiculo }}</td>
                                <td class="celda-entidad"><div class="entidad-nombre" :title="vehiculo.nombre_vehiculo">{{ vehiculo.nombre_vehiculo }}</div></td>
                                <td>{{ vehiculo.tipo_vehiculo?.nombre_tipo || '-' }}</td>
                                <td class="celda-entidad"><div class="entidad-nombre" :title="vehiculo.tipo_unidad?.tipo_unidad">{{ vehiculo.tipo_unidad?.tipo_unidad || '-' }}</div></td>
                                <td>{{ vehiculo.marca || '-' }}</td>
                                <td>{{ vehiculo.modelo || '-' }}</td>
                                <td class="celda-id">{{ vehiculo.placa || '-' }}</td>
                                <td>
                                    <span :class="getEstadoBadgeClass(vehiculo.estado_vehiculo?.estado)">
                                        {{ vehiculo.estado_vehiculo?.estado || 'Sin estado' }}
                                    </span>
                                </td>
                                <td>{{ vehiculo.orden }}</td>
                                <td class="col-acciones">
                                    <button class="btn-icon btn-icon-view" @click="gestionarAsignacion(vehiculo)" title="Gestionar asignación" aria-label="Gestionar asignación">
                                        <i class="bi bi-person-gear"></i>
                                    </button>
                                    <button class="btn-icon btn-icon-view" @click="verDetalle(vehiculo)" title="Ver detalle" aria-label="Ver detalle">
                                        <i class="bi bi-eye"></i>
                                    </button>
                                    <button class="btn-icon btn-icon-edit" @click="editarVehiculo(vehiculo)" title="Editar" aria-label="Editar">
                                        <i class="bi bi-pencil"></i>
                                    </button>
                                    <button class="btn-icon btn-icon-del" @click="eliminarVehiculo(vehiculo.id_vehiculo)" title="Eliminar" aria-label="Eliminar">
                                        <i class="bi bi-trash"></i>
                                    </button>
                                </td>
                            </tr>
                            <tr v-if="!vehiculosFiltrados.length" class="empty-row">
                                <td colspan="10">No se encontraron vehículos</td>
                            </tr>
                        </tbody>
                    </table>
            </div>
            <PaginacionListado :pagina="paginaActualDe(vehiculosFiltrados)" :total-paginas="totalPaginasDe(vehiculosFiltrados)"
                :total="vehiculosFiltrados.length" :por-pagina="porPagina" :en-pagina="paginar(vehiculosFiltrados).length"
                etiqueta="vehículos" @cambiar="pagina = $event" />
        </div>

        <!-- Modal para Vehículo -->
        <div v-if="showModalVehiculo" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ modoEdicion ? 'Editar Vehículo' : 'Nuevo Vehículo' }}
                        </h5>
                        <button type="button" class="btn-close" @click="cerrarModalVehiculo"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="guardarVehiculo">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label for="nombreVehiculo" class="form-label required">Nombre del Vehículo</label>
                                        <input 
                                            type="text" 
                                            class="form-control" 
                                            id="nombreVehiculo" 
                                            v-model="formVehiculo.nombre_vehiculo"
                                            :class="{ 'is-invalid': errors.nombre_vehiculo }"
                                            placeholder="Ingrese el nombre del vehículo"
                                            maxlength="100"
                                            required
                                        >
                                        <div v-if="errors.nombre_vehiculo" class="invalid-feedback">
                                            {{ errors.nombre_vehiculo }}
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-md-3">
                                    <div class="mb-3">
                                        <label for="placa" class="form-label">Placa</label>
                                        <input 
                                            type="text" 
                                            class="form-control" 
                                            id="placa" 
                                            v-model="formVehiculo.placa"
                                            :class="{ 'is-invalid': errors.placa }"
                                            placeholder="ABC-123"
                                            maxlength="20"
                                        >
                                        <div v-if="errors.placa" class="invalid-feedback">
                                            {{ errors.placa }}
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-md-3">
                                    <div class="mb-3">
                                        <label for="orden" class="form-label required">Orden</label>
                                        <input 
                                            type="number" 
                                            class="form-control" 
                                            id="orden" 
                                            v-model="formVehiculo.orden"
                                            :class="{ 'is-invalid': errors.orden }"
                                            placeholder="1"
                                            min="1"
                                            required
                                        >
                                        <div v-if="errors.orden" class="invalid-feedback">
                                            {{ errors.orden }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label for="tipoVehiculo" class="form-label">Tipo de Vehículo</label>
                                        <select 
                                            class="form-control" 
                                            id="tipoVehiculo" 
                                            v-model="formVehiculo.id_tipo_vehiculo"
                                            :class="{ 'is-invalid': errors.id_tipo_vehiculo }"
                                        >
                                            <option value="">Seleccione un tipo</option>
                                            <option v-for="tipo in tiposVehiculo" :key="tipo.id" :value="tipo.id">
                                                {{ tipo.nombre_tipo || tipo.tipo_vehiculo }}
                                            </option>
                                        </select>
                                        <div v-if="errors.id_tipo_vehiculo" class="invalid-feedback">
                                            {{ errors.id_tipo_vehiculo }}
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label for="estadoVehiculo" class="form-label">Estado</label>
                                        <select 
                                            class="form-control" 
                                            id="estadoVehiculo" 
                                            v-model="formVehiculo.estado_vehiculo_id"
                                            :class="{ 'is-invalid': errors.estado_vehiculo_id }"
                                        >
                                            <option value="">Seleccione un estado</option>
                                            <option v-for="estado in estadosVehiculo" :key="estado.id" :value="estado.id">
                                                {{ estado.estado }}
                                            </option>
                                        </select>
                                        <div v-if="errors.estado_vehiculo_id" class="invalid-feedback">
                                            {{ errors.estado_vehiculo_id }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Los tipos de unidad tienen nombres largos: fila completa para que no se recorten -->
                            <div class="row">
                                <div class="col-12">
                                    <div class="mb-3">
                                        <label for="tipoUnidad" class="form-label">Tipo de Unidad</label>
                                        <select 
                                            class="form-control" 
                                            id="tipoUnidad" 
                                            v-model="formVehiculo.tipo_unidad"
                                            :class="{ 'is-invalid': errors.tipo_unidad }"
                                        >
                                            <option value="">Seleccione un tipo</option>
                                            <option v-for="tipo in tiposUnidad" :key="tipo.id" :value="tipo.id">
                                                {{ tipo.tipo_unidad }}
                                            </option>
                                        </select>
                                        <div v-if="errors.tipo_unidad" class="invalid-feedback">
                                            {{ errors.tipo_unidad }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-4">
                                    <div class="mb-3">
                                        <label for="marca" class="form-label">Marca</label>
                                        <input 
                                            type="text" 
                                            class="form-control" 
                                            id="marca" 
                                            v-model="formVehiculo.marca"
                                            :class="{ 'is-invalid': errors.marca }"
                                            placeholder="Ej: Toyota, Volvo, etc."
                                            maxlength="100"
                                        >
                                        <div v-if="errors.marca" class="invalid-feedback">
                                            {{ errors.marca }}
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-md-4">
                                    <div class="mb-3">
                                        <label for="modelo" class="form-label">Modelo</label>
                                        <input 
                                            type="text" 
                                            class="form-control" 
                                            id="modelo" 
                                            v-model="formVehiculo.modelo"
                                            :class="{ 'is-invalid': errors.modelo }"
                                            placeholder="Ej: Hilux, FH16, etc."
                                            maxlength="100"
                                        >
                                        <div v-if="errors.modelo" class="invalid-feedback">
                                            {{ errors.modelo }}
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-md-4">
                                    <div class="mb-3">
                                        <label for="telefono" class="form-label">Teléfono</label>
                                        <input 
                                            type="text" 
                                            class="form-control" 
                                            id="telefono" 
                                            v-model="formVehiculo.telefono"
                                            :class="{ 'is-invalid': errors.telefono }"
                                            placeholder="Ej: 987654321"
                                            maxlength="20"
                                        >
                                        <div v-if="errors.telefono" class="invalid-feedback">
                                            {{ errors.telefono }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="cerrarModalVehiculo">Cancelar</button>
                        <button type="button" class="btn btn-primary" @click="guardarVehiculo" :disabled="isLoading">
                            <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
                            {{ modoEdicion ? 'Actualizar' : 'Guardar' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal para Gestionar Asignación -->
        <div v-if="showModalAsignacion" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Gestionar Asignación - {{ vehiculoSeleccionado?.nombre_vehiculo }}
                        </h5>
                        <button type="button" class="btn-close" @click="cerrarModalAsignacion"></button>
                    </div>
                    <div class="modal-body">
                        <!-- Asignación actual -->
                        <div v-if="asignacionActual" class="card mb-3">
                            <div class="card-header bg-info text-white">
                                <h6 class="mb-0">Asignación Actual</h6>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <p><strong>Chofer:</strong> {{ asignacionActual.chofer_nombre || 'Sin asignar' }}</p>
                                        <p><strong>Auxiliar:</strong> {{ asignacionActual.auxiliar_nombre || 'Sin asignar' }}</p>
                                    </div>
                                    <div class="col-md-6">
                                        <p><strong>Fecha Creación:</strong> {{ formatearFecha(asignacionActual.fecha_creacion) }}</p>
                                        <p><strong>Fecha Modificación:</strong> {{ formatearFecha(asignacionActual.fecha_modificacion) }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Formulario de nueva asignación -->
                        <form @submit.prevent="guardarAsignacion">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label for="chofer" class="form-label required">Chofer</label>
                                        <select 
                                            class="form-control" 
                                            id="chofer" 
                                            v-model="formAsignacion.id_chofer"
                                            :class="{ 'is-invalid': errorsAsignacion.id_chofer }"
                                            
                                        >
                                            <option value="">Seleccione un chofer</option>
                                            <option v-for="chofer in choferes" :key="chofer.id_personal" :value="chofer.id_personal">
                                                {{ chofer.nombre }} {{ chofer.apellidos }}
                                            </option>
                                        </select>
                                        <div v-if="errorsAsignacion.id_chofer" class="invalid-feedback">
                                            {{ errorsAsignacion.id_chofer }}
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label for="auxiliar" class="form-label">Auxiliar (Opcional)</label>
                                        <select 
                                            class="form-control" 
                                            id="auxiliar" 
                                            v-model="formAsignacion.id_auxiliar"
                                            :class="{ 'is-invalid': errorsAsignacion.id_auxiliar }"
                                        >
                                            <option value="">Sin auxiliar</option>
                                            <option v-for="auxiliar in auxiliares" :key="auxiliar.id_personal" :value="auxiliar.id_personal">
                                                {{ auxiliar.nombre }} {{ auxiliar.apellidos }}
                                            </option>
                                        </select>
                                        <div v-if="errorsAsignacion.id_auxiliar" class="invalid-feedback">
                                            {{ errorsAsignacion.id_auxiliar }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="cerrarModalAsignacion">Cancelar</button>
                        <button type="button" class="btn btn-primary" @click="guardarAsignacion" :disabled="isLoading">
                            <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
                            {{ asignacionActual ? 'Actualizar Asignación' : 'Crear Asignación' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal para Ver Detalle -->
        <div v-if="showModalDetalle" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Detalle del Vehículo - {{ vehiculoSeleccionado?.nombre_vehiculo }}
                        </h5>
                        <button type="button" class="btn-close" @click="cerrarModalDetalle"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row" v-if="vehiculoSeleccionado">
                            <div class="col-md-6">
                                <table class="table table-bordered">
                                    <tr>
                                        <td class="fw-bold">ID:</td>
                                        <td>{{ vehiculoSeleccionado.id_vehiculo }}</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Nombre:</td>
                                        <td>{{ vehiculoSeleccionado.nombre_vehiculo }}</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Placa:</td>
                                        <td>{{ vehiculoSeleccionado.placa || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Marca:</td>
                                        <td>{{ vehiculoSeleccionado.marca || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Modelo:</td>
                                        <td>{{ vehiculoSeleccionado.modelo || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Orden:</td>
                                        <td>{{ vehiculoSeleccionado.orden }}</td>
                                    </tr>
                                </table>
                            </div>
                            <div class="col-md-6">
                                <table class="table table-bordered">
                                    <tr>
                                        <td class="fw-bold">Tipo Vehículo:</td>
                                        <td>{{ vehiculoSeleccionado.tipo_vehiculo?.nombre_tipo || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Tipo Unidad:</td>
                                        <td>{{ vehiculoSeleccionado.tipo_unidad?.tipo_unidad || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Estado:</td>
                                        <td>
                                            <span :class="getEstadoBadgeClass(vehiculoSeleccionado.estado_vehiculo?.estado)">
                                                {{ vehiculoSeleccionado.estado_vehiculo?.estado || 'Sin estado' }}
                                            </span>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="cerrarModalDetalle">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import PaginacionListado from '@/components/PaginacionListado.vue'
import paginacionLocal from '@/mixins/paginacionLocal'

export default {
    name: 'GestionVehiculos',
    components: { PaginacionListado },
    mixins: [paginacionLocal],
    watch: {
        // Los filtros se aplican al escribir: cualquier cambio vuelve a la página 1
        filtros: { deep: true, handler() { this.pagina = 1 } },
    },
    data() {
        return {
            isLoading: false,
            
            // Modales
            showModalVehiculo: false,
            showModalAsignacion: false,
            showModalDetalle: false,
            
            // Modos de edición
            modoEdicion: false,
            
            // Datos
            vehiculos: [],
            tiposVehiculo: [],
            tiposUnidad: [],
            estadosVehiculo: [],
            choferes: [],
            auxiliares: [],
            vehiculoSeleccionado: null,
            asignacionActual: null,
            
            // Filtros
            filtros: {
                nombre_vehiculo: '',
                placa: '',
                id_tipo_vehiculo: '',
                estado_vehiculo_id: ''
            },
            
            // Formularios
            formVehiculo: {
                id_vehiculo: null,
                nombre_vehiculo: '',
                id_tipo_vehiculo: '',
                tipo_unidad: '',
                marca: '',
                modelo: '',
                placa: '',
                estado_vehiculo_id: '',
                orden: 1
            },
            formAsignacion: {
                id_asignacion: null,
                id_vehiculo: null,
                id_chofer: '',
                id_auxiliar: ''
            },
            
            // Errores
            errors: {},
            errorsAsignacion: {}
        }
    },
    computed: {
        vehiculosFiltrados() {
            let filtrados = this.vehiculos

            if (this.filtros.nombre_vehiculo) {
                filtrados = filtrados.filter(vehiculo =>
                    vehiculo.nombre_vehiculo && vehiculo.nombre_vehiculo.toLowerCase().includes(this.filtros.nombre_vehiculo.toLowerCase())
                )
            }

            if (this.filtros.placa) {
                filtrados = filtrados.filter(vehiculo =>
                    vehiculo.placa && vehiculo.placa.toLowerCase().includes(this.filtros.placa.toLowerCase())
                )
            }

            if (this.filtros.id_tipo_vehiculo) {
                filtrados = filtrados.filter(vehiculo => 
                    vehiculo.id_tipo_vehiculo == this.filtros.id_tipo_vehiculo
                )
            }

            if (this.filtros.estado_vehiculo_id) {
                filtrados = filtrados.filter(vehiculo => 
                    vehiculo.estado_vehiculo_id == this.filtros.estado_vehiculo_id
                )
            }

            return filtrados
        }
    },
    async mounted() {
        await Promise.all([
            this.cargarVehiculos(),
            this.cargarTiposVehiculo(),
            this.cargarTiposUnidad(),
            this.cargarEstadosVehiculo(),
            this.cargarPersonal()
        ])
    },
    methods: {
        // Formatear fecha
        formatearFecha(fecha) {
            if (!fecha) return '-'
            return new Date(fecha).toLocaleString('es-PE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            })
        },

        // Obtener clase CSS para badge de estado
        getEstadoBadgeClass(estado) {
            const clases = {
                'Disponible': 'badge bg-success',
                'No Disponible': 'badge bg-warning text-dark', 
                'Ocupado': 'badge bg-danger',
                'En Mantenimiento': 'badge bg-secondary',
                'Activo': 'badge bg-success',
                'Inactivo': 'badge bg-danger'
            }
            return clases[estado] || 'badge bg-light text-dark'
        },

        // Cargar datos
        async cargarVehiculos() {
            this.isLoading = true
            try {
                const response = await axios.get('vehiculos')
                this.vehiculos = response.data.data
            } catch (error) {
                console.error('Error cargando vehículos:', error)
                Swal.fire('Error', 'Error al cargar los vehículos', 'error')
            } finally {
                this.isLoading = false
            }
        },

        async cargarTiposVehiculo() {
            try {
                const response = await axios.get('tipo-vehiculo')
                this.tiposVehiculo = response.data?.data || response.data || []
            } catch (error) {
                console.error('Error cargando tipos de vehículo:', error)
            }
        },

        async cargarTiposUnidad() {
            try {
                const response = await axios.get('tipo-unidades')
                this.tiposUnidad = response.data?.data || response.data || []
            } catch (error) {
                console.error('Error cargando tipos de unidad:', error)
            }
        },

        async cargarEstadosVehiculo() {
            try {
                const response = await axios.get('estado-vehiculo')
                this.estadosVehiculo = response.data?.data || response.data || []
            } catch (error) {
                console.error('Error cargando estados de vehículo:', error)
                // Si no existe el endpoint, creamos estados básicos
                this.estadosVehiculo = [
                    { id: 1, estado: 'Disponible' },
                    { id: 2, estado: 'Ocupado' },
                    { id: 3, estado: 'No Dispobible' }
                ]
            }
        },

        async cargarPersonal() {
            try {
                const response = await axios.get('datos-personal')
                const personal = response.data?.data?.data || response.data?.data || response.data || []
                this.choferes = personal.filter(p => p.cargo && p.cargo.toLowerCase().includes('chofer'))
                this.auxiliares = personal.filter(p => p.cargo && p.cargo.toLowerCase().includes('auxiliar'))
            } catch (error) {
                console.error('Error cargando personal:', error)
            }
        },

        // Filtros
        filtrarVehiculos() {
            // Los filtros se aplican automáticamente mediante computed
        },

        limpiarFiltros() {
            this.filtros = {
                nombre_vehiculo: '',
                placa: '',
                id_tipo_vehiculo: '',
                estado_vehiculo_id: ''
            }
        },

        // Modal vehículo
        abrirModalVehiculo() {
            this.modoEdicion = false
            this.formVehiculo = {
                id_vehiculo: null,
                nombre_vehiculo: '',
                id_tipo_vehiculo: '',
                tipo_unidad: '',
                marca: '',
                modelo: '',
                placa: '',
                estado_vehiculo_id: '',
                orden: 1,
                telefono: ''
            }
            this.errors = {}
            this.showModalVehiculo = true
        },

        editarVehiculo(vehiculo) {
            this.modoEdicion = true
            this.formVehiculo = {
                id_vehiculo: vehiculo.id_vehiculo,
                nombre_vehiculo: vehiculo.nombre_vehiculo || '',
                id_tipo_vehiculo: vehiculo.id_tipo_vehiculo || '',
                tipo_unidad: vehiculo.tipo_unidad?.id || '',
                marca: vehiculo.marca || '',
                modelo: vehiculo.modelo || '',
                placa: vehiculo.placa || '',
                telefono: vehiculo.telefono || '',
                estado_vehiculo_id: vehiculo.estado_vehiculo_id || '',
                orden: vehiculo.orden || 1
            }
            this.errors = {}
            this.showModalVehiculo = true
        },

        cerrarModalVehiculo() {
            this.showModalVehiculo = false
            this.errors = {}
        },

        // Modal detalle
        verDetalle(vehiculo) {
            this.vehiculoSeleccionado = vehiculo
            this.showModalDetalle = true
        },

        cerrarModalDetalle() {
            this.showModalDetalle = false
            this.vehiculoSeleccionado = null
        },

        // Modal asignación
        async gestionarAsignacion(vehiculo) {
            this.vehiculoSeleccionado = vehiculo
            await this.cargarAsignacionActual(vehiculo.id_vehiculo)
            
            this.formAsignacion = {
                id_asignacion: this.asignacionActual?.id_asignacion || null,
                id_vehiculo: vehiculo.id_vehiculo,
                id_chofer: this.asignacionActual?.id_chofer || '',
                id_auxiliar: this.asignacionActual?.id_auxiliar || ''
            }
            
            this.errorsAsignacion = {}
            this.showModalAsignacion = true
        },

        async cargarAsignacionActual(idVehiculo) {
            try {
                const response = await axios.get(`asignacion-vehiculo/vehiculo/${idVehiculo}`)
                this.asignacionActual = response.data.data
            } catch (error) {
                console.error('Error cargando asignación actual:', error)
                this.asignacionActual = null
            }
        },

        cerrarModalAsignacion() {
            this.showModalAsignacion = false
            this.vehiculoSeleccionado = null
            this.asignacionActual = null
            this.errorsAsignacion = {}
        },

        // Validaciones
        validarFormularioVehiculo() {
            this.errors = {}

            if (!this.formVehiculo.nombre_vehiculo.trim()) {
                this.errors.nombre_vehiculo = 'El nombre del vehículo es requerido'
            }

            if (!this.formVehiculo.orden || this.formVehiculo.orden < 1) {
                this.errors.orden = 'El orden debe ser mayor a 0'
            }

            return Object.keys(this.errors).length === 0
        },

        validarFormularioAsignacion() {
            this.errorsAsignacion = {}

            // if (!this.formAsignacion.id_chofer) {
            //     this.errorsAsignacion.id_chofer = 'Debe seleccionar un chofer'
            // }

            return Object.keys(this.errorsAsignacion).length === 0
        },

        // Guardar
        async guardarVehiculo() {
            if (!this.validarFormularioVehiculo()) {
                return
            }

            this.isLoading = true
            try {
                const data = {
                    nombre_vehiculo: this.formVehiculo.nombre_vehiculo.trim(),
                    id_tipo_vehiculo: this.formVehiculo.id_tipo_vehiculo || null,
                    tipo_unidad: this.formVehiculo.tipo_unidad || null,
                    marca: this.formVehiculo.marca?.trim() || null,
                    modelo: this.formVehiculo.modelo?.trim() || null,
                    placa: this.formVehiculo.placa?.trim() || null,
                    estado_vehiculo_id: this.formVehiculo.estado_vehiculo_id || null,
                    orden: this.formVehiculo.orden,
                    telefono: this.formVehiculo.telefono?.trim() || null,
                }

                if (this.modoEdicion) {
                    await axios.put(`vehiculos/${this.formVehiculo.id_vehiculo}`, data)
                    Swal.fire('Éxito', 'Vehículo actualizado correctamente', 'success')
                } else {
                    await axios.post('vehiculos', data)
                    Swal.fire('Éxito', 'Vehículo creado correctamente', 'success')
                }
                
                this.cerrarModalVehiculo()
                await this.cargarVehiculos()
            } catch (error) {
                console.error('Error guardando vehículo:', error)
                if (error.response?.data?.errors) {
                    this.errors = error.response.data.errors
                } else {
                    Swal.fire('Error', error.response?.data?.message || 'Error al guardar el vehículo', 'error')
                }
            } finally {
                this.isLoading = false
            }
        },

        async guardarAsignacion() {
            if (!this.validarFormularioAsignacion()) {
                return
            }

            this.isLoading = true
            try {
                const data = {
                    id_vehiculo: this.formAsignacion.id_vehiculo,
                    id_chofer: this.formAsignacion.id_chofer,
                    id_auxiliar: this.formAsignacion.id_auxiliar || null
                }

                
                    await axios.post(`asignacion-vehiculo/${this.formAsignacion.id_vehiculo}`, data)
                    Swal.fire('Éxito', 'Asignación actualizada correctamente', 'success')
                
                
                this.cerrarModalAsignacion()
                await this.cargarVehiculos()
            } catch (error) {
                console.error('Error guardando asignación:', error)
                if (error.response?.data?.errors) {
                    this.errorsAsignacion = error.response.data.errors
                } else {
                    Swal.fire('Error', error.response?.data?.message || 'Error al guardar la asignación', 'error')
                }
            } finally {
                this.isLoading = false
            }
        },

        // Eliminar
        async eliminarVehiculo(id) {
            const result = await Swal.fire({
                title: '¿Estás seguro?',
                text: 'Esta acción no se puede deshacer',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            })

            if (result.isConfirmed) {
                this.isLoading = true
                try {
                    await axios.delete(`vehiculos/${id}`)
                    Swal.fire('Eliminado', 'Vehículo eliminado correctamente', 'success')
                    await this.cargarVehiculos()
                } catch (error) {
                    console.error('Error eliminando vehículo:', error)
                    Swal.fire('Error', error.response?.data?.message || 'Error al eliminar el vehículo', 'error')
                } finally {
                    this.isLoading = false
                }
            }
        }
    }
}
</script>

<style scoped>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    color: white;
}

.modal.show {
    display: block !important;
}

.badge {
    font-size: 0.8em;
}

.btn-group .btn {
    margin-right: 2px;
}

.table th {
    font-weight: 600;
    background-color: #f8f9fa;
    border-top: 1px solid #dee2e6;
}

.text-danger {
    color: #dc3545 !important;
}

.is-invalid {
    border-color: #dc3545;
}

.invalid-feedback {
    display: block;
}

.required::after {
    content: ' *';
    color: red;
}

.btn-group .btn {
    margin-right: 0;
}


.table td {
    vertical-align: middle;
}
</style>